import { type ReactNode } from "react";
import { AnimatePresence, motion } from "motion/react";
import { createPortal } from "react-dom";
import { Check } from "lucide-react";

interface ToastProps {
  icon?: ReactNode;
  isVisible: boolean;
  message: string;
}

export function Toast({ icon, message, isVisible }: ToastProps) {
  return createPortal(
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed bottom-8 left-1/2 z-50 -translate-x-1/2"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 8 }}
          transition={{ duration: 0.2 }}
        >
          <div className="flex items-center gap-2 rounded-xl border border-black/10 bg-black px-5 py-2.5 shadow-lg dark:border-white/10 dark:bg-white">
            {icon ?? <Check className="h-4 w-4 text-accent-green" />}
            <span className="text-sm font-medium text-white dark:text-black">
              {message}
            </span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body,
  );
}
